import { createFileRoute } from '@tanstack/react-router';

import { Security } from 'features/account/Security';

export const Route = createFileRoute('/_authenticated/account/_shell/security')({
  component: AccountSecurityRoute
});

function AccountSecurityRoute() {
  return <Security />;
}
